import {
    SPU_CREATED_DOWN_KEY,
    SPU_CREATED_UP_KEY,
    SALE_YESTERDAY_BY_BLACK_DOWN_KEY,
    SALE_YESTERDAY_BY_BLACK_UP_KEY,
    SALE_THREE_BY_BLACK_DOWN_KEY,
    SALE_THREE_BY_BLACK_UP_KEY,
    SALE_SEVEN_BY_BLACK_DOWN_KEY,
    SALE_SEVEN_BY_BLACK_UP_KEY,
    SALE_FIFTEEN_BY_BLACK_DOWN_KEY,
    SALE_FIFTEEN_BY_BLACK_UP_KEY,
    SALE_THIRTY_BY_BLACK_DOWN_KEY,
    SALE_THIRTY_BY_BLACK_UP_KEY,
    SALE_NINETY_BY_BLACK_DOWN_KEY,
    SALE_NINETY_BY_BLACK_UP_KEY,
    SALE_HUNDRED_EIGHTY_BY_BLACK_DOWN_KEY,
    SALE_HUNDRED_EIGHTY_BY_BLACK_UP_KEY,
    SALE_ONE_YEAR_BY_BLACK_DOWN_KEY,
    SALE_ONE_YEAR_BY_BLACK_UP_KEY
} from '@/components/GoodsSort/helper'

/** 商品无类目时，类目选项默认值 */
export const NO_CATEGORY = 'unknown'
export const NO_CATEGORY_NAME = '无类目（系统）'

export const saleSortObj = {
    saleYesterdayOutCombo: {
        desc: SALE_YESTERDAY_BY_BLACK_DOWN_KEY,
        asc: SALE_YESTERDAY_BY_BLACK_UP_KEY
    },
    saleThreeOutCombo: {
        desc: SALE_THREE_BY_BLACK_DOWN_KEY,
        asc: SALE_THREE_BY_BLACK_UP_KEY
    },
    saleSevenOutCombo: {
        desc: SALE_SEVEN_BY_BLACK_DOWN_KEY,
        asc: SALE_SEVEN_BY_BLACK_UP_KEY
    },
    saleFifteenOutCombo: {
        desc: SALE_FIFTEEN_BY_BLACK_DOWN_KEY,
        asc: SALE_FIFTEEN_BY_BLACK_UP_KEY
    },
    saleThirtyOutCombo: {
        desc: SALE_THIRTY_BY_BLACK_DOWN_KEY,
        asc: SALE_THIRTY_BY_BLACK_UP_KEY
    },
    saleNinetyByShowBlackList: {
        desc: SALE_NINETY_BY_BLACK_DOWN_KEY,
        asc: SALE_NINETY_BY_BLACK_UP_KEY
    },
    saleHundredEightyByShowBlackList: {
        desc: SALE_HUNDRED_EIGHTY_BY_BLACK_DOWN_KEY,
        asc: SALE_HUNDRED_EIGHTY_BY_BLACK_UP_KEY
    },
    saleOneYearByShowBlackList: {
        desc: SALE_ONE_YEAR_BY_BLACK_DOWN_KEY,
        asc: SALE_ONE_YEAR_BY_BLACK_UP_KEY
    },
    created: {
        desc: SPU_CREATED_DOWN_KEY,
        asc: SPU_CREATED_UP_KEY
    }
}

export const saleSortKey = {
    [SALE_YESTERDAY_BY_BLACK_DOWN_KEY]: {
        code: 'saleYesterdayOutCombo',
        order: 'desc'
    },
    [SALE_YESTERDAY_BY_BLACK_UP_KEY]: {
        code: 'saleYesterdayOutCombo',
        order: 'asc'
    },
    [SALE_THREE_BY_BLACK_DOWN_KEY]: {
        code: 'saleThreeOutCombo',
        order: 'desc'
    },
    [SALE_THREE_BY_BLACK_UP_KEY]: {
        code: 'saleThreeOutCombo',
        order: 'asc'
    },
    [SALE_SEVEN_BY_BLACK_DOWN_KEY]: {
        code: 'saleSevenOutCombo',
        order: 'desc'
    },
    [SALE_SEVEN_BY_BLACK_UP_KEY]: {
        code: 'saleSevenOutCombo',
        order: 'asc'
    },
    [SALE_FIFTEEN_BY_BLACK_DOWN_KEY]: {
        code: 'saleFifteenOutCombo',
        order: 'desc'
    },
    [SALE_FIFTEEN_BY_BLACK_UP_KEY]: {
        code: 'saleFifteenOutCombo',
        order: 'asc'
    },
    [SALE_THIRTY_BY_BLACK_DOWN_KEY]: {
        code: 'saleThirtyOutCombo',
        order: 'desc'
    },
    [SALE_THIRTY_BY_BLACK_UP_KEY]: {
        code: 'saleThirtyOutCombo',
        order: 'asc'
    },
    [SPU_CREATED_DOWN_KEY]: {
        code: 'created',
        order: 'desc'
    },
    [SPU_CREATED_UP_KEY]: {
        code: 'created',
        order: 'asc'
    }
}
export const DIMENSION_SPU = 'DIMENSION_SPU' //  按款维度 spu维度
export const DIMENSION_SKU = 'DIMENSION_SKU' //  按SKU 维度

export const DIMENSION_SPU_ROWKEY = 'spuId'
export const DIMENSION_SKU_ROWKEY = 'skuId'

const DIMENSION_MAP = {
    [DIMENSION_SPU]: DIMENSION_SPU_ROWKEY,
    [DIMENSION_SKU]: DIMENSION_SKU_ROWKEY
}

export const transDimensionRowKey = dimension => {
    return DIMENSION_MAP[dimension]
}

export const GOODS_SKU_TYPE_COMBINE = 'combine' // 商品sku类型组合装
export const GOODS_SHELF_COMBINE_GROUPSALES_KEY = 'DRP_COMBO' // 组合装拼款上架
export const GOODS_SHELF_COMBINE_MULTIGROUPSALES_KEY = 'MULTI_COMBO' // 超级拼款上架
export const GOODS_SHELF_COMBINE_PARTNER_SPU_KEY = 'P_SPU_COMBO' // 分销商品按款式

export const SPU_ITEM_SOURCE_SUPPLIER = 'ERP_SUPPLIER' //  spu 来源，erp
export const SPU_ITEM_SOURCE_GYL = 'GYL' //  spu 来 供应链

export const TAB_ERP_BASIC_INFO = 'erpBasicInfo' // erp 基础资料导航
export const TAB_ERP_GOODS_ANALYSIS = 'GOODS_ANALYSIS' // erp 基础资料导航

export const OWNGOODS_PATH_OBJ = {
    [window.PROJECT_CONFIG.channelTerminalName]: {
        style: '/channel/my/myGoods/ownGoods/index',
        sku: '/channel/my/myGoods/ownGoods/sku'
    },
    [window.PROJECT_CONFIG.supplierTerminalName]: {
        style: '/manage/goods/goodsManage/index',
        sku: '/manage/goods/goodsManage/sku'
    }
}

export const GOODS_TYPE_ENUM = {
    style: 'style',
    sku: 'sku'
}

export const OWNGOODS_GOODS_TYPE_LIST = [
    {
        label: '按款式',
        value: 'style',
        path: OWNGOODS_PATH_OBJ[window.PROJECT_CONFIG.terminalName]?.style
    },
    {
        label: '按SKU',
        value: 'sku',
        path: OWNGOODS_PATH_OBJ[window.PROJECT_CONFIG.terminalName]?.sku
    }
]

export const ONLINESTOREGOODS_PATH_OBJ = {
    [window.PROJECT_CONFIG.channelTerminalName]: {
        style: '/channel/my/myGoods/onlineStoreGoods/index',
        sku: '/channel/my/myGoods/onlineStoreGoods/sku'
    },
    [window.PROJECT_CONFIG.supplierTerminalName]: {
        style: '/manage/goods/onlineStoreGoods/index',
        sku: '/manage/goods/onlineStoreGoods/sku'
    }
}

export const ONLINESTOREGOODS_GOODS_TYPE_LIST = [
    {
        label: '按款式',
        value: 'style',
        path: ONLINESTOREGOODS_PATH_OBJ[window.PROJECT_CONFIG.terminalName]?.style
    },
    {
        label: '按SKU',
        value: 'sku',
        path: ONLINESTOREGOODS_PATH_OBJ[window.PROJECT_CONFIG.terminalName]?.sku
    }
]

// 我的收藏-商品[大图选品]KEY
export const FAVORITES_GOODS_TYPE_INDEX = 'index'
// 我的收藏-商品[基础资料KEY
export const FAVORITES_GOODS_TYPE_ERP = 'erp'
// 我的收藏-小站[基础资料KEY
export const FAVORITES_SITE_TYPE_INDEX = 'site'

export const FAVORITES_PATH_OBJ = {
    [window.PROJECT_CONFIG.channelTerminalName]: {
        [FAVORITES_GOODS_TYPE_INDEX]: '/channel/my/myGoods/favoritesGoods/index',
        [FAVORITES_GOODS_TYPE_ERP]: '/channel/my/myGoods/favoritesGoods/erp',
        [FAVORITES_SITE_TYPE_INDEX]: '/channel/my/myGoods/favoritesGoods/site'
    },
    [window.PROJECT_CONFIG.supplierTerminalName]: {
        [FAVORITES_GOODS_TYPE_INDEX]: '/manage/goods/favoritesGoods/index',
        [FAVORITES_GOODS_TYPE_ERP]: '/manage/goods/favoritesGoods/erp',
        [FAVORITES_SITE_TYPE_INDEX]: '/manage/goods/favoritesGoods/site'
    }
}

export const FAVORITES_GOODS_TYPE_LIST = [
    {
        label: '大图选品',
        value: FAVORITES_GOODS_TYPE_INDEX,
        path: FAVORITES_PATH_OBJ[window.PROJECT_CONFIG.terminalName]?.index
    },
    {
        label: '基础资料',
        value: FAVORITES_GOODS_TYPE_ERP,
        path: FAVORITES_PATH_OBJ[window.PROJECT_CONFIG.terminalName]?.erp
    }
]

export const NO_EDIT_GOODS_AUTH_TIP = '您没有该功能权限，请联系管理员开启'

// 基础资料配置
const mode = PROJECT_CONFIG.sentryMode || PROJECT_CONFIG.mode

export const erpBaseGoodsUrlObj = {
    dev: 'http://xt.jushuitan.com:1024/',
    // dev: 'https://dev-src.jushuitan.com/erp-web-group/erp-scm-goods/',
    test: 'https://dev-src.jushuitan.com/erp-web-group/erp-scm-goods/',
    uat: 'https://dev-src.jushuitan.com/erp-web-group/erp-scm-goods/',
    // 我们的预发环境连他们的正式
    pre: 'https://pre-src.erp321.com/erp-web-group/erp-scm-goods/',
    prod: 'https://src.erp321.com/erp-web-group/erp-scm-goods/'
}

// 基础资料代理链接
const erpAgentHost = 'https://dailisrc.jushuitan.com/erp-web-group/erp-scm-goods/'

export const erpBaseGoodsHost = isAgent => {
    // 代理登录供应链访问的基础资料链接，只考虑生产环境
    if (isAgent && mode === 'prod') {
        return erpAgentHost
    }

    return erpBaseGoodsUrlObj[mode || 'dev']
}

export const erpBaseGoodsPath = isAgent => {
    return `${erpBaseGoodsHost(isAgent)}goodsInventoryManagement`
}

// 选择平台/店铺使用场景[线上商品管理页面]
export const QUERY_PLATFORM_SHOP_SCENE_BY_ONLINE = 'ONLINE'

// 选择平台/店铺使用场景[店铺商品管理页面]
export const QUERY_PLATFORM_SHOP_SCENE_BY_SHOP = 'SHOP'

// 选择平台/店铺使用场景[运营分析管理页面]
export const QUERY_PLATFORM_SHOP_SCENE_BY_OPERATION = 'OPERATION'

// 是否排除爆款专区
export const FRESHMAN_STATUS_TYPE = [
    {
        value: true,
        label: '在爆款专区'
    },
    {
        value: false,
        label: '不在爆款专区'
    }
]

export const erpBaseGroupUrlObj = {
    dev: 'https://dev-src.scm121.com/erp-web-group/',
    test: 'https://dev-src.scm121.com/erp-web-group/',
    uat: 'https://dev-src.scm121.com/erp-web-group/',
    // 我们的预发环境连他们的正式
    pre: 'https://pre-src.erp321.com/erp-web-group/',
    prod: 'https://src.scm121.com/erp-web-group/'
}

// erp 前端分离项目
export const erpBaseGroupHost = () => {
    return erpBaseGroupUrlObj[mode || 'dev']
}
